





















import { Component, Vue } from "vue-property-decorator";
import { Html5QrcodeScanner } from "html5-qrcode";
@Component({
  components: {},
})
export default class QrcodeScannerVue extends Vue {
  public decodeBarcode = "";
  public html5QrcodeScanner: any = null;
  mounted() {
    const userAgent = navigator.userAgent.toLowerCase();
    // Detectar móvil
    const isMobile =
      /iphone|ipod|android.*mobile|windows phone|blackberry/i.test(userAgent);
    // Detectar tablet
    const isTablet = /ipad|android(?!.*mobile)|tablet/i.test(userAgent);
    // Determinar tipo de dispositivo
    if (isMobile || isTablet) {
      this.html5QrcodeScanner = new Html5QrcodeScanner(
        "reader",
        {
          videoConstraints: {
            facingMode: { exact: "environment" },
          },
          fps: 10,
          qrbox: { width: 250, height: 250 },
        },
        /* verbose= */ false
      );
    } else {
      this.html5QrcodeScanner = new Html5QrcodeScanner(
        "reader",
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
        },
        /* verbose= */ false
      );
    }

    this.html5QrcodeScanner.render(this.onScan, this.errorLectura);
  }

  onScan(decodedText: string, decodedResult: string) {
    // handle the message here :)
    if (this.decodeBarcode !== decodedText) {
      this.emitir();
    }
    this.decodeBarcode = decodedText;

    this.$emit("result", decodedText, decodedResult);
  }

  errorLectura(error: any) {
    // handle scan failure, usually better to ignore and keep scanning.
    // for example:
    //console.warn(`Code scan error = ${error}`);
  }

  public detenerCamara() {
    try {
      document.getElementById("html5-qrcode-button-camera-stop")!.click();
    } catch (error) {}

    /*this.html5QrcodeScanner
      .stop()
      .then((ignore: any) => {
        // QR Code scanning is stopped.
      })
      .catch((err: any) => {
        // Stop failed, handle it.
      });*/
  }
  beforeDestroy() {
    this.detenerCamara();
  }

  emitir() {
    this.emitirPitido(200, 840, "square");
  }

  emitirPitido(
    duracion: number = 500,
    frecuencia: number = 440,
    tipo: OscillatorType = "sine"
  ): void {
    // Crear el contexto de audio
    const audioContext = new (window.AudioContext ||
      (window as any).webkitAudioContext)();

    // Crear un oscilador
    const oscillator = audioContext.createOscillator();

    // Configurar la frecuencia y el tipo de onda del oscilador
    oscillator.frequency.setValueAtTime(frecuencia, audioContext.currentTime);
    oscillator.type = tipo;

    // Conectar el oscilador al destino (los altavoces)
    oscillator.connect(audioContext.destination);

    // Iniciar el oscilador
    oscillator.start();

    // Detener el oscilador después de la duración especificada
    setTimeout(() => {
      oscillator.stop();
      audioContext.close();
    }, duracion);
  }
}
